import { render, staticRenderFns } from "./bdcqzm.vue?vue&type=template&id=a1a6df06&scoped=true"
import script from "./bdcqzm.vue?vue&type=script&lang=js"
export * from "./bdcqzm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a6df06",
  null
  
)

export default component.exports